import type { Claim, Entity } from "../domain";

const labelForEvidence = (value: Claim["evidenceClass"]) => value.replace("_", " ");

export const FrontierFeed = ({ claims, entities }: { claims: Claim[]; entities: Entity[] }) => {
  const entitiesById = new Map(entities.map((entity) => [entity.id, entity]));
  return (
    <section className="section-block" id="now" aria-labelledby="frontier-heading">
      <div className="section-heading">
        <div>
          <h2 id="frontier-heading">State of the frontier</h2>
          <p>Consequential events, with the evidence boundary kept visible.</p>
        </div>
        <a href="/now.md">Read as Markdown <span aria-hidden="true">→</span></a>
      </div>
      <div className="frontier-feed" id="claims">
        {claims.map((claim) => {
          const entity = entitiesById.get(claim.entityId);
          return (
            <article className="claim-row" key={claim.id}>
              <div className="claim-class">
                <span className={`evidence-dot evidence-${claim.evidenceClass}`} aria-hidden="true" />
                <span>{labelForEvidence(claim.evidenceClass)}</span>
              </div>
              <div className="claim-copy">
                <p className="claim-organization">{entity?.organization ?? "Unknown organization"}</p>
                <h3>{entity?.name ?? claim.title}</h3>
                <p>{claim.summary}</p>
              </div>
              <div className="claim-source">
                <span>Effective</span>
                <time dateTime={claim.effectiveAt}>{claim.effectiveAt.slice(0, 10)}</time>
                <span>Primary source</span>
                <a href={claim.sources[0]?.url} target="_blank" rel="noreferrer">
                  {claim.sources[0]?.publisher} <span aria-hidden="true">↗</span>
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

